// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"panel-layout_wrapper__162u1","header":"panel-layout_header__IRiez","body":"panel-layout_body__3OIKM"};